import MuiSwitch, { SwitchProps as MuiSwitchProps } from '@mui/material/Switch';
import { styled } from '@mui/material/styles';

export type SwitchProps = MuiSwitchProps & {
  disabled?: boolean;
};

const StyledSwitch = styled(MuiSwitch)<{ disabled?: boolean }>(({ theme, disabled }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: disabled ? '#194589' : theme.palette.primary.main
  },
  '& .MuiSwitch-switchBase': {
    color: disabled ? '#54555F' : '#9B9B9B'
  },
  '& .MuiSwitch-track': {
    backgroundColor: disabled ? '#234173' : '#54555F'
  }
}));

const Switch = (props: SwitchProps): JSX.Element => {
  const { disabled, ...rest } = props;
  return <StyledSwitch disabled={disabled} {...rest} />;
};

export default Switch;
